/**
 * Shared Tailwind CSS classes for editable cell inputs
 * Centralizes styling to avoid duplication across input types
 */

/**
 * Base class for all text-like inputs (text, date, datetime, number)
 */
export const EDIT_INPUT_BASE_CLASS =
  "min-w-[120px] h-8 text-sm border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 bg-card shadow-sm";

/**
 * Class for date inputs (same as base)
 */
export const EDIT_INPUT_DATE_CLASS = EDIT_INPUT_BASE_CLASS;

/**
 * Class for datetime inputs (slightly wider)
 */
export const EDIT_INPUT_DATETIME_CLASS =
  "min-w-[140px] h-8 text-sm border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 bg-card shadow-sm";

/**
 * Class for number inputs (same as base)
 */
export const EDIT_INPUT_NUMBER_CLASS = EDIT_INPUT_BASE_CLASS;

/**
 * Class for range/slider inputs (probability, etc.)
 */
export const EDIT_SLIDER_CLASS =
  "h-8 w-full min-w-[100px] accent-blue-600 cursor-pointer";

/**
 * Class for select inputs
 */
export const EDIT_SELECT_CLASS =
  "min-w-[120px] h-8 text-sm bg-card shadow-sm border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200";

/**
 * Class for textarea inputs
 */
export const EDIT_TEXTAREA_CLASS =
  "w-full h-full text-sm border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 bg-card shadow-sm resize-none overflow-y-auto";

/**
 * Wrapper class for edit container layout
 */
export const EDIT_CONTAINER_WRAPPER_CLASS =
  "relative gap-2 p-2 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg shadow-sm ring-1 ring-blue-100 z-50 dark:from-blue-950/40 dark:to-indigo-950/40 dark:border-blue-800 dark:ring-blue-900/50";

/**
 * Wrapper class for textarea layout variant
 */
export const EDIT_CONTAINER_TEXTAREA_WRAPPER_CLASS =
  "flex flex-col h-full max-h-32 overflow-hidden";

/**
 * Wrapper class for inline layout variant
 */
export const EDIT_CONTAINER_INLINE_WRAPPER_CLASS = "flex items-center";

/**
 * Content wrapper class for textarea
 */
export const EDIT_CONTENT_TEXTAREA_CLASS = "bg-card flex-1 min-h-0 overflow-hidden";

/**
 * Content wrapper class for inline
 */
export const EDIT_CONTENT_INLINE_CLASS = "flex-1";

/**
 * Save/cancel buttons wrapper class
 */
export const EDIT_BUTTONS_WRAPPER_CLASS = "flex items-center gap-1";

/**
 * Save/cancel buttons wrapper class for textarea
 */
export const EDIT_BUTTONS_TEXTAREA_CLASS = "flex-shrink-0";
